import React, { FC } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, Stack, Typography } from '@mui/material';

const ChatBotHeader: FC<{ closeBot: VoidFunction }> = ({ closeBot }) => {
  return (
    <Stack
      style={{
        backgroundColor: '#005a9e',
        padding: '5px 15px',
        borderRadius: '5px 5px 0 0',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: 'white',
        fontWeight: 'bold',
      }}
    >
      <Typography>Ultra AI</Typography>
      <IconButton onClick={closeBot} sx={{ color: 'white' }}>
        <ClearIcon />
      </IconButton>
    </Stack>
  );
};

export default ChatBotHeader;
